var cell_default = {
  "cell": "_--mRo",
  "header": "Jhame",
  "selected": "T7NPr",
  "editing": "jyJEG",
  "singleSelection": "WNv0A",
  "hideLastBlock": "_4UPqy",
  "editorWrapper": "a26sJ",
  "viewerWrapper": "UIMqx",
  "hideFirstBlock": "i59J2",
  "editor": "_0t3ce",
  "edit": "_3Tme7",
  "view": "ZM-wo",
  "editingToolbarWrapper": "g9Tkr",
  "selectAll": "Xb-A2",
  "disableSelection": "CyZg1"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
